
import { Component, Vue } from "vue-property-decorator";
import graph from "@/graph";
import ebiEditbar from "@/components/editbar/ebiEditbar.vue";
import { UrlShorten, UrlShortenList } from "@/graph/servicecloud/urlshortener";
import UrlShortenerEdit from "./UrlShortenerEdit.vue";
import ebiActionsButtonBar from "@/components/actionsButtonBar/ebiActionsButtonBar.vue";
import { EventBus } from "@/events/event-bus";

@Component({
	components: {
		ebiEditbar,
		ebiActionsButtonBar,
		UrlShortenerEdit,		
	},
})
export default class UrlShortener extends Vue
{
	loadingTable = true;
	entryList: UrlShortenList = {
		page: 0,
		total: 0,
		entries: [],
	};
	totalEntries = 0;
	page = 1;
	pages = 1;

	editbarTitle = "";
	showEditbar = false;
	showAddDialog = false;
	selectedEntry: UrlShorten = { identifier: "", path: "", target: "", redisid: "", description: "", createdby: "", created: "", hasVariants: false };
	createButtonLoading = false;

	addLinkForm = {
		target: "",
		path: "",
		description: "",
		createdby: "unknown",
	};

	handleCurrentPageChange(value: number)
	{
		console.log("UrlShortener::handleCurrentPageChange", value);
		this.loadTable(value - 1);
	}

	handleEdit(index: number, row: UrlShorten)
	{
		console.log("UrlShortener::handleEdit", index, row);

		this.editbarTitle = "Edit: " + row.path;
		this.showEditbar = true;
		this.selectedEntry = row;

		console.log("UrlShortener::handleEdit::END");
	}

	async createLink()
	{
		console.log("UrlShortener::createLink", this.addLinkForm);
		this.createButtonLoading = true;

		const result = await graph.servicecloud.urlshortener.create(
			this.addLinkForm.target,
			this.addLinkForm.createdby,
			this.addLinkForm.description,
			this.addLinkForm.path
		);

		console.log("UrlShortener::createLink", "response:", result);

		if(!result.success)
		{
			this.$notify.error({
				title: 'Error',
				message: result.error,
			});
			this.createButtonLoading = false;
			return;
		}

		this.$notify.success({
			title: "Link Created",
			dangerouslyUseHTMLString: true,
			message: "Link was successfully created.<br>The created Path is:<br><a href=\"https://eis.mn/" + result.path + "\" target=_blank><b>https://eis.mn/" + result.path + "</b></a>",
			duration: 0,
		});

		await this.loadTable();
		this.createButtonLoading = false;
		this.showAddDialog = false;
		this.addLinkForm.target = "";
		this.addLinkForm.description = "";
		this.addLinkForm.path = "";
	}

	async loadTable(page = 0)
	{
		console.log("UrlShortener::loadTable");

		this.loadingTable = true;
		this.reset();
		const result = await graph.servicecloud.urlshortener.list(page);
		console.log("UrlShortener::loadTable", "result:", result);
		this.entryList = result;
		this.totalEntries = result.total;
		this.page = page + 1;
		this.pages = Math.ceil(result.total / 10);
		this.loadingTable = false;
	}

  reset() {
    this.entryList ={
      page: 0,
      total: 0,
      entries: [],
    };
    this.page = 1;
    this.pages = 1;

    this.editbarTitle = "";
    this.showEditbar = false;
    this.showAddDialog = false;
    this.selectedEntry = { identifier: "", path: "", target: "", redisid: "", description: "", createdby: "", created: "", hasVariants: false };
    this.createButtonLoading = false;

    this.addLinkForm = {
      target: "",
      path: "",
      description: "",
      createdby: "unknown",
    };
  }

	mounted()
	{
		this.addLinkForm.createdby = this.$store.state.user.username;
		this.loadTable();

    EventBus.$on('environment-changed', () => {
      this.loadTable();
    });
	}

}
